import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as organisationAdminActions from '../../ducks/organisation-admin'
import AccountCreation from '../AccountCreation'

class OrganisationAccountCreationContainer extends React.Component {
  render() {
    return (
      <AccountCreation
        organisation={this.props.currentOrganisation.organisation}
        onAdd={this.props.actions.addAccount}
        isSuperAdminView={false}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    currentOrganisation: state.account.get('currentOrganisation')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(organisationAdminActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationAccountCreationContainer)



// WEBPACK FOOTER //
// ./src/components/smart/OrganisationAccountCreationContainer.js